import React from "react";
import PropTypes from "prop-types";
import { Message, Icon } from "semantic-ui-react";

export const OverrideNotification = ({ overrideData }) => {
  if (!overrideData) return null;

  return (
    <Message info icon>
      <Icon name="edit" />
      <Message.Content>
        <Message.Header>Override Amounts Active</Message.Header>
        <p>
          This patron has overridden fine amounts from the overdue slip.
          {overrideData.useManualTotal && (
            <span>
              Using manual total:{" "}
              <strong>₱{overrideData.totalAmount.toFixed(2)}</strong>
            </span>
          )}
        </p>
      </Message.Content>
    </Message>
  );
};

OverrideNotification.propTypes = {
  overrideData: PropTypes.object,
};
